import React, { useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import style from "../../styles/Join.module.css";
import SearchIcon from "@mui/icons-material/Search";
import PropTypes from "prop-types";
import Member from "./Member";
import * as constants from "../../Components/constants";

const BASE_URL = constants.BASE_URL;

//Navbar Items
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const JoinGroup = ({ open, handleClose, groupID }) => {
  const [fullWidth] = useState(true);
  const [maxWidth] = useState("sm");
  const [searchText, setSearchText] = useState("");
  const [value, setValue] = React.useState(0);
  const [allUser, setAllUser] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleUser = (text) => {
    fetch(`${BASE_URL}/group/${groupID}/all-users/?search=${text}`, {
      method: "GET",
      headers: {
        Authorization: `Token ${
          typeof window !== "undefined"
            ? localStorage.getItem("auth_token")
            : ""
        }`,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        setAllUser(data);
      });
  };

  React.useEffect(() => {
    handleUser("");
  }, [groupID]);

  const handleSearch = (e) => {
    setSearchText(e.target.value);
    handleUser(e.target.value);
  };

  return (
    <>
      <div>
        <Dialog
          fullWidth={fullWidth}
          maxWidth={maxWidth}
          open={open}
          onClose={handleClose}
        >
          <DialogTitle className="fs-6 border-bottom pb-1">
            <b>Suggest Members,</b>
            <small className="mx-1">{allUser.length}</small>

            <div className="py-3">
              <small>
                New people & Pages who join this group will appear here. Those
                people can add here who can surve group Activities.
              </small>
              <div className={`${style.search} mt-2`}>
                <input
                  onKeyUp={handleSearch}
                  type="text"
                  className={style.searchTerm}
                  placeholder="Find a Member"
                />
                <button type="submit" className={`${style.searchButton}`}>
                  <SearchIcon />
                </button>
              </div>
            </div>
          </DialogTitle>
          <DialogContent className="py-2">
            <div>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                centered
              >
                <Tab label="Add Group Member" />
              </Tabs>
            </div>
            <div className="border-top">
              <TabPanel value={value} index={0}>
                <Member
                  allUser={allUser}
                  groupID={groupID}
                  handleUser={handleUser}
                />
              </TabPanel>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default JoinGroup;
